// Contact.js
import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import { FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const Contact = () => {
  const form = useRef();
  const [messageStatus, setMessageStatus] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_l6paiqh',
      'template_flreteg',
      form.current,
      'O6JHazCU7FFTBjsCt'
    ).then(
      () => {
        setMessageStatus('success');
        form.current.reset();
        setTimeout(() => setMessageStatus(null), 4000);
      },
      () => {
        setMessageStatus('error');
        setTimeout(() => setMessageStatus(null), 4000);
      }
    );
  };

  return (
    <section id="contact" className="contact-section">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Top Info Cards */}
        <div className="contact-info-grid">
          {[{
            icon: <FaPhoneAlt size={24} style={{ color: '#ef4444' }} />, title: 'Call Us', desc: 'Speak directly with our experts', info: <a href="tel:+19719985516" style={{ color: '#1d4ed8', textDecoration: 'none' }}>+1 (971) 998-5516</a>
          }, {
            icon: <FaEnvelope size={24} style={{ color: '#3b82f6' }} />, title: 'Email Us', desc: 'Send us your inquiries anytime', info: <a href="mailto:hr@dhriti.solutions" style={{ color: '#1d4ed8', textDecoration: 'none' }}>hr@dhriti.solutions</a>
          }, {
            icon: <FaClock size={24} style={{ color: '#facc15' }} />, title: 'Business Hours', desc: "We're available:", info: 'Mon-Fri: 9:00 AM - 5:00 PM EST'
          }].map((item, idx) => (
            <div key={idx} className="contact-info-card">
              <div style={{ marginBottom: '1rem' }}>{item.icon}</div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>{item.title}</h4>
              <p style={{ margin: 0 }}>{item.desc}</p>
              <p style={{ color: '#1d4ed8', fontWeight: '600', marginTop: '0.5rem' }}>{item.info}</p>
            </div>
          ))}
        </div>

        {/* Form & Contacts */}
        <div className="contact-layout">
          {/* Form */}
          <div className="contact-form-panel">
            <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem' }}>Send Us a Message</h2>

            <AnimatePresence>
              {messageStatus && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  style={{
                    marginBottom: '1rem',
                    padding: '1rem',
                    backgroundColor: messageStatus === 'success' ? '#d1fae5' : '#fee2e2',
                    color: messageStatus === 'success' ? '#065f46' : '#991b1b',
                    borderRadius: '8px',
                    fontWeight: 500
                  }}
                >
                  {messageStatus === 'success' ? 'Message sent successfully!' : 'Failed to send message. Please try again.'}
                </motion.div>
              )}
            </AnimatePresence>

            <form ref={form} onSubmit={sendEmail} style={{ display: 'grid', gap: '1rem' }}>
              <div className="form-row">
                <label className="form-field">
                  <span className="field-label">Full Name *</span>
                  <input name="full_name" placeholder="Full Name *" required style={{ flex: 1, padding: '0.75rem' }} />
                </label>
                <label className="form-field">
                  <span className="field-label">Email Address *</span>
                  <input name="email" placeholder="Email Address *" required type="email" style={{ flex: 1, padding: '0.75rem' }} />
                </label>
              </div>
              <div className="form-row">
                <label className="form-field">
                  <span className="field-label">Phone Number</span>
                  <input name="phone" placeholder="Phone Number" style={{ flex: 1, padding: '0.75rem' }} />
                </label>
                <label className="form-field">
                  <span className="field-label">Company Name</span>
                  <input name="company" placeholder="Company Name" style={{ flex: 1, padding: '0.75rem' }} />
                </label>
              </div>
              <label className="form-field">
                <span className="field-label">Service *</span>
                <select name="service" required style={{ padding: '0.75rem' }}>
                  <option value="">Select a service</option>
                  <option value="Software">Software</option>
                  <option value="AI ML">AI & ML</option>
                  <option value="Data Science">Data Science</option>
                  <option value="Cybersecurity">Cybersecurity</option>
                  <option value="Coaching">Coaching</option>
                  <option value="Consulting">Consulting</option>
                  <option value="Staffing">Staffing</option>
                </select>
              </label>
              <label className="form-field">
                <span className="field-label">Subject *</span>
                <input name="subject" placeholder="Subject *" required style={{ padding: '0.75rem' }} />
              </label>
              <label className="form-field">
                <span className="field-label">Message *</span>
                <textarea name="message" placeholder="Message *" required rows="5" style={{ padding: '0.75rem' }}></textarea>
              </label>
              <button type="submit" style={{ background: 'linear-gradient(to right, #1e3a8a, #10b981)', color: 'white', padding: '1rem', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Cards */}
          <div className="contact-details-panel">
            <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>Our Contacts</h3>
            {[{
              title: 'Albany (HQ) & Human Resources',
              address: '20 Sutton Dr, Cohoes, NY 12047',
              phone: '(971)-998-5516',
              email: 'hr@dhriti.solutions'
            }].map((item, idx) => (
              <div key={idx} style={{ background: '#f1f5f9', padding: '1rem', borderRadius: '6px', marginBottom: '1rem' }}>
                <h4 style={{ fontWeight: '600', marginBottom: '0.5rem' }}>{item.title}</h4>
                {item.address && <p>{item.address}</p>}
                {item.phone && <p><FaPhoneAlt style={{ marginRight: '6px' }} /> <a href="tel:+19719985516" style={{ color: '#1d4ed8', textDecoration: 'none' }}>{item.phone}</a></p>}
                {item.emails
                  ? item.emails.map((email, i) => (
                    <p key={i}><FaEnvelope style={{ marginRight: '6px' }} /> {email}</p>
                  ))
                  : item.email && <p><FaEnvelope style={{ marginRight: '6px' }} /> <a href={`mailto:${item.email}`} style={{ color: '#1d4ed8', textDecoration: 'none' }}>{item.email}</a></p>
                }
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
